// extracted by mini-css-extract-plugin
module.exports = {"fsCtaLink":"Ab"};